import { render, staticRenderFns } from "./RemittancePaid.vue?vue&type=template&id=01fbe4a3"
import script from "./RemittancePaid.vue?vue&type=script&lang=js"
export * from "./RemittancePaid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports